import { render, staticRenderFns } from "./LearningTimeLimitPanel.vue?vue&type=template&id=7ef7beee&scoped=true"
import script from "./LearningTimeLimitPanel.vue?vue&type=script&lang=js"
export * from "./LearningTimeLimitPanel.vue?vue&type=script&lang=js"
import style0 from "./LearningTimeLimitPanel.vue?vue&type=style&index=0&id=7ef7beee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ef7beee",
  null
  
)

export default component.exports